export function setFetching({ commit }, payload) {
  commit('setFetching', payload);
}

export function setFetched({ commit }, payload) {
  commit('setFetched', payload);
}

export default { setFetching, setFetched };
